export const WISTIA_UPLOAD_API = "https://upload.wistia.com";

export const WISTIA_EMBED_BASE_URL = "https://fast.wistia.net/embed/iframe";
